import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, FolderPlus, FolderOpen, FileText, MessageSquare, ArrowLeft } from 'lucide-react';
import CreateProject from '../components/engineer/CreateProject';
import MyProjects from '../components/engineer/MyProjects';
import SpecsSection from '../components/engineer/SpecsSection';
import ContactSection from '../components/engineer/ContactSection';
import './EngineerDashboard.css';

const EngineerDashboard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState('projects');

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user') || 'null');
    if (!storedUser) {
      navigate('/login');
    } else if (storedUser.role === 'admin') {
      navigate('/admin');
    } else if (storedUser.role === 'customer') {
      navigate('/customer');
    } else {
      setUser(storedUser);
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/');
  };

  if (!user) return null;

  const tabs = [
    { id: 'projects', label: 'Τα Έργα μου', icon: FolderOpen },
    { id: 'create', label: 'Δημιουργία Έργου', icon: FolderPlus },
    { id: 'specs', label: 'Προδιαγραφές', icon: FileText },
    { id: 'messages', label: 'Επικοινωνία', icon: MessageSquare }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'projects':
        return <MyProjects />;
      case 'create':
        return <CreateProject onSuccess={() => setActiveTab('projects')} />;
      case 'specs':
        return <SpecsSection />;
      case 'messages':
        return <ContactSection />;
      default:
        return <MyProjects />;
    }
  };

  return (
    <div className="engineer-dashboard">
      <header className="engineer-header">
        <button 
          className="back-to-home-btn"
          onClick={() => navigate('/')}
          aria-label="Επιστροφή στην αρχική"
        >
          <ArrowLeft size={20} />
          <span>Αρχική</span>
        </button>

        <h1>Dashboard Μηχανικού</h1>

        <div className="user-info">
          <span>Μηχανικός: {user.full_name || user.username}</span>
          <button 
            className="logout-btn"
            onClick={handleLogout}
            aria-label="Αποσύνδεση"
          >
            <LogOut size={18} />
            <span>Αποσύνδεση</span>
          </button>
        </div>
      </header>

      <div className="engineer-tabs">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              className={`engineer-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <Icon size={20} />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>

      <main className="engineer-content">
        {renderTabContent()}
      </main>
    </div>
  );
};

export default EngineerDashboard;